import { IHome } from '@/modules/home/types';

export const sumOperation = (
  operation: IHome.IOperationsWidgetSchema | undefined
) => (operation ? operation.periodic + operation.technical : 0);
